import classNames from 'clsx';
import React from 'react';

import CrmZone from '@swf/components/CrmZone/CrmZone';
import { CRMZone } from '@swf/core/enums';

import BonusContainer from '../BonusContainer/BonusContainer';

import { height } from './CRMBonus.scss';

interface Props {
  selected?: boolean;
}

const CRMBonus: React.FC<Props> = ({ selected }) => (
  <BonusContainer selected={selected}>
    <div className={classNames(height)}>
      <CrmZone zoneId={CRMZone.SWC_WELCOME_BONUS} componentType="Single" dynamicHeight />
    </div>
  </BonusContainer>
);

export default CRMBonus;
